export * from './qrefBanc.component';